export default "__VITE_ASSET__Tc9QCubU__"